import { BaseTable, Button, Loading, Pagination } from "../../../../components";
import { FilterSection } from "./components";
import { Link } from "react-router-dom";
import { convertNumber } from "utils";
import { getCurrentRow } from "../utils";
import { useList } from "./utils";
import { useContext, useEffect } from "react";
import { DataContext } from "../utils/contexts";

export function ItemsBuild() {
  const getItemsBuild = useList();

  const { setData } = useContext(DataContext);

  useEffect(() => {
    setData(getItemsBuild?.data);
  }, [ getItemsBuild?.data, setData ]);

  return (
    <section className="my-2 flex flex-col gap-3">
      <FilterSection
        filter={getItemsBuild?.filter}
        handleCheckbox={getItemsBuild?.handleCheckbox}
        handlePage={getItemsBuild?.handlePage}
        handlePerPage={getItemsBuild?.handlePerPage}
        handleSearchGroup={getItemsBuild?.handleSearchGroup}
        reset={getItemsBuild?.reset}
      />

      <div className="overflow-x-auto max-h-[calc(100vh-460px)]">
        <BaseTable className="border-collapse">
          <thead className="bg-white sticky top-0 z-[0] !bg-black !text-white">
            <tr>
              <th>NO</th>
              <th>GROUP</th>
              <th>BSI</th>
              <th>BUILD</th>
              <th>CODE</th>
              <th>DESCRIPTION</th>
              <th>PRICE</th>
              <th>CAC</th>
              <th>SELLING PRICE</th>
              <th>SOH</th>
              <th>UNIT INVENTORY</th>
              <th>ACTION</th>
            </tr>
          </thead>

          <tbody>
            {getItemsBuild?.isLoading || !getItemsBuild?.data.length ? (
              <tr>
                <td colSpan={12}>
                  <Loading loading={getItemsBuild?.isLoading} errorText="No data available" />
                </td>
              </tr>
            ) : (
              <>
                {getItemsBuild?.data?.map((item, key) => (
                  <tr key={key}>
                    <td>{getCurrentRow(getItemsBuild?.filter?.page, getItemsBuild?.pagination?.size, key)}</td>
                    <td>{item.mr_product_group_name}</td>
                    <td>{item.bsi}</td>

                    <td className="text-center">
                      <input
                        checked
                        type="checkbox"
                        className="checkbox checkbox-primary"
                      />
                    </td>

                    <td className="text-center">{item.product_barcode}</td>
                    <td>{item.product_name}</td>
                    <td className="text-right">
                      {convertNumber(item.avg_price).intoCurrency}
                    </td>
                    <td className="text-right">
                      {convertNumber(item.cac).intoCurrency}
                    </td>
                    <td className="text-right">
                      {convertNumber(item.price_retail).intoCurrency}
                    </td>
                    <td className="text-right">
                      {convertNumber(item.soh).intoCurrency}
                    </td>
                    <td>{item.mr_unit_name}</td>

                    <td className="w-[120px] text-center">
                      <Link
                        to={`/inventory/transaction/build-item/${item.product_id}`}
                      >
                        <Button color="primary">BUILD</Button>
                      </Link>
                    </td>
                  </tr>
                ))}
              </>
            )}
          </tbody>
        </BaseTable>

        {!Boolean(getItemsBuild?.isLoading || !getItemsBuild?.data?.length) && (
          <Pagination
            currentPage={getItemsBuild?.filter?.page}
            limit={getItemsBuild?.filter?.limit}
            totalPage={getItemsBuild?.pagination?.pages}
            total={getItemsBuild?.pagination?.total}
            size={getItemsBuild?.pagination?.size}
            onPageChange={getItemsBuild?.handlePage}
            onAddShow={(res) => getItemsBuild?.handlePerPage(parseInt(res))}
          />
        )}
      </div>
    </section>
  );
}
